(function () {
  'use strict';

  var AGREEMENT_TEXT = 'I agree to the terms and conditions above';
  var FIX_CLASS = 'pv-tally-agreement-visual-fix';

  function setImportant(el, prop, value) {
    if (el && el.style) el.style.setProperty(prop, value, 'important');
  }

  function findAgreement(root) {
    if (!root) return null;
    var doc = root.ownerDocument || document;
    var walker;
    try {
      walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    } catch (e) {
      return null;
    }

    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || node.nodeValue.indexOf(AGREEMENT_TEXT) === -1) continue;
      var textEl = node.parentElement;
      if (!textEl) continue;

      var cursor = textEl;
      var checkbox = null;
      var container = null;
      for (var i = 0; cursor && i < 10; i += 1, cursor = cursor.parentElement) {
        if (cursor.querySelector) {
          checkbox = cursor.querySelector('input[type="checkbox"]');
          if (checkbox) {
            container = cursor;
            break;
          }
        }
      }
      if (checkbox && container) return { textEl: textEl, checkbox: checkbox, container: container };
    }

    if (root.querySelectorAll) {
      var all = root.querySelectorAll('*');
      for (var j = 0; j < all.length; j += 1) {
        if (all[j].shadowRoot) {
          var nested = findAgreement(all[j].shadowRoot);
          if (nested) return nested;
        }
      }
    }
    return null;
  }

  function createVisualFix(root, agreement) {
    var existing = root.querySelector && root.querySelector('.' + FIX_CLASS);
    if (existing) {
      // If Tally rerendered and replaced its real checkbox, rebuild the proxy so
      // our click handler always targets the current live control.
      if (existing._pvRealCheckbox !== agreement.checkbox) {
        existing.remove();
      } else {
        var existingBox = existing.querySelector('input[type="checkbox"]');
        if (existingBox) existingBox.checked = !!agreement.checkbox.checked;
        existing.setAttribute('aria-checked', agreement.checkbox.checked ? 'true' : 'false');
        return;
      }
    }

    var doc = agreement.checkbox.ownerDocument || document;
    var bar = doc.createElement('label');
    bar.className = FIX_CLASS;
    bar.setAttribute('data-pv-tally-terms-fix', 'true');

    var box = doc.createElement('input');
    box.type = 'checkbox';
    box.checked = !!agreement.checkbox.checked;
    box.setAttribute('aria-label', AGREEMENT_TEXT);

    var copy = doc.createElement('span');
    copy.textContent = AGREEMENT_TEXT;

    bar.appendChild(box);
    bar.appendChild(copy);

    setImportant(bar, 'position', 'fixed');
    setImportant(bar, 'left', '50%');
    setImportant(bar, 'bottom', '14px');
    setImportant(bar, 'transform', 'translateX(-50%)');
    setImportant(bar, 'z-index', '2147483647');
    setImportant(bar, 'box-sizing', 'border-box');
    setImportant(bar, 'display', 'flex');
    setImportant(bar, 'align-items', 'center');
    setImportant(bar, 'justify-content', 'flex-start');
    setImportant(bar, 'gap', '12px');
    setImportant(bar, 'width', 'min(540px, calc(100vw - 32px))');
    setImportant(bar, 'min-height', '62px');
    setImportant(bar, 'padding', '14px 18px');
    setImportant(bar, 'margin', '0');
    setImportant(bar, 'border', '1px solid rgba(122, 79, 255, 0.55)');
    setImportant(bar, 'border-radius', '14px');
    setImportant(bar, 'background', '#080018');
    setImportant(bar, 'color', '#ffffff');
    setImportant(bar, 'font-size', '13px');
    setImportant(bar, 'line-height', '1.4');
    setImportant(bar, 'white-space', 'normal');
    setImportant(bar, 'text-align', 'left');
    setImportant(bar, 'cursor', 'pointer');
    setImportant(bar, 'box-shadow', '0 12px 32px rgba(0, 0, 0, 0.35)');

    setImportant(box, 'appearance', 'auto');
    setImportant(box, '-webkit-appearance', 'checkbox');
    setImportant(box, 'position', 'static');
    setImportant(box, 'display', 'block');
    setImportant(box, 'flex', '0 0 20px');
    setImportant(box, 'width', '20px');
    setImportant(box, 'min-width', '20px');
    setImportant(box, 'height', '20px');
    setImportant(box, 'margin', '0');
    setImportant(box, 'padding', '0');
    setImportant(box, 'transform', 'none');

    setImportant(copy, 'display', 'block');
    setImportant(copy, 'flex', '1 1 auto');
    setImportant(copy, 'min-width', '0');
    setImportant(copy, 'width', 'auto');
    setImportant(copy, 'white-space', 'normal');
    setImportant(copy, 'overflow', 'visible');
    setImportant(copy, 'word-break', 'normal');
    setImportant(copy, 'overflow-wrap', 'break-word');

    // Leave Tally's own row in place for layout, but make its broken contents invisible.
    // The real checkbox remains in the DOM and continues to drive Tally's logic.
    setImportant(agreement.textEl, 'visibility', 'hidden');
    var originalWrap = agreement.checkbox.parentElement;
    if (originalWrap && agreement.container.contains(originalWrap)) {
      setImportant(originalWrap, 'visibility', 'hidden');
    } else {
      setImportant(agreement.checkbox, 'visibility', 'hidden');
    }

    // Proxy the visual control to Tally's REAL checkbox by clicking it.
    // Tally's app listens to its own click/state lifecycle, so directly setting
    // checkbox.checked is not enough to unlock the Continue to Cart button.
    function syncFromReal() {
      box.checked = !!agreement.checkbox.checked;
      bar.setAttribute('aria-checked', box.checked ? 'true' : 'false');
    }

    function activateRealCheckbox(event) {
      if (event) event.preventDefault();

      // Use the browser's native click path so Tally receives the same event
      // sequence it would receive from a customer clicking its own checkbox.
      agreement.checkbox.click();

      // Sync immediately and again after Tally has had a chance to update its
      // reactive state / rerender.
      syncFromReal();
      requestAnimationFrame(syncFromReal);
      setTimeout(syncFromReal, 50);
    }

    box.addEventListener('click', activateRealCheckbox);
    copy.addEventListener('click', activateRealCheckbox);

    agreement.checkbox.addEventListener('input', syncFromReal);
    agreement.checkbox.addEventListener('change', syncFromReal);
    agreement.checkbox.addEventListener('click', function () {
      requestAnimationFrame(syncFromReal);
    });

    bar._pvRealCheckbox = agreement.checkbox;
    syncFromReal();

    var mount = root.nodeType === 11 ? root : (root.body || root.documentElement || root);
    mount.appendChild(bar);
  }

  function removeStaleFixes(root) {
    if (!root || !root.querySelectorAll) return;
    var bars = root.querySelectorAll('.' + FIX_CLASS);
    for (var i = 0; i < bars.length; i += 1) bars[i].remove();

    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j += 1) {
      if (all[j].shadowRoot) removeStaleFixes(all[j].shadowRoot);
    }
  }

  function applyFix() {
    var result = findAgreement(document.body);
    if (!result) {
      removeStaleFixes(document);
      return;
    }

    var root = result.checkbox.getRootNode ? result.checkbox.getRootNode() : document;
    createVisualFix(root, result);
  }

  function start() {
    applyFix();
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        applyFix();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    var tries = 0;
    var timer = setInterval(function () {
      applyFix();
      tries += 1;
      if (tries > 80) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
